export default "__VITE_ASSET__CeGxjH4w__"